import React from 'react';
import propTypes from 'prop-types';
import ContactCard from 'tailwind-components/CarrierResources/ContactCard';
import ExternalLinkButton from 'tailwind-components/ExternalLinkButton/ExternalLinkButton';
import HtmlContent from 'tailwind-components/HtmlContent/HtmlContent';

// horizontal carrier header card at the top of the oep updates page: name and
// description on the left, contact rows below, external links stacked on the
// right. mirrors the sections of tailwind-components/CarrierResources/CarrierDetail
// but re-laid-out for a wide banner-style container.
function CarrierHeader({ carrier }) {
  const hasContact =
    carrier.brokerSupportNumber ||
    carrier.memberSupportNumber ||
    carrier.Broker_Support_Email ||
    carrier.Broker_Commission_Email;

  const hasLinks =
    carrier.carrierBrokerPortal ||
    carrier.enrollmentPortal ||
    carrier.omWebsiteLink;

  return (
    <div
      data-tour='oep-carrier-header'
      className='rounded-xl border border-grey-lightest bg-white p-4 lg:p-6'
    >
      <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between lg:gap-8'>
        <div className='min-w-0 flex-1'>
          <h2 className='m-0 mb-2 text-2xl font-bold text-black lg:text-3xl'>
            {carrier.name}
          </h2>
          {carrier.description && (
            <HtmlContent
              html={carrier.description}
              className='text-left text-md text-grey'
            />
          )}
          {hasContact && (
            <div className='mt-4'>
              <p className='m-0 mb-3 text-left text-lg font-medium tracking-wide text-black'>
                Contact Information
              </p>
              <div className='grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3'>
                {carrier.brokerSupportNumber && (
                  <ContactCard
                    title='Broker Support Phone Number'
                    info={carrier.brokerSupportNumber}
                  />
                )}
                {carrier.memberSupportNumber && (
                  <ContactCard
                    title='Member Support Phone Number'
                    info={carrier.memberSupportNumber}
                  />
                )}
                {carrier.Broker_Support_Email && (
                  <ContactCard
                    title='Broker Support Email'
                    info={carrier.Broker_Support_Email.toLowerCase()}
                    hasButton={false}
                  />
                )}
                {carrier.Broker_Commission_Email && (
                  <ContactCard
                    title='Broker Commission Email'
                    info={carrier.Broker_Commission_Email.toLowerCase()}
                    hasButton={false}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        {hasLinks && (
          <div className='shrink-0 lg:w-[220px]'>
            <p className='m-0 mb-3 text-left text-lg font-medium tracking-wide text-black'>
              External Links
            </p>
            <div className='flex flex-col gap-2'>
              {carrier.carrierBrokerPortal && (
                <ExternalLinkButton
                  href={carrier.carrierBrokerPortal}
                  text='Broker Portal'
                  size='xsmall'
                  fill={false}
                />
              )}
              {carrier.enrollmentPortal && (
                <ExternalLinkButton
                  href={carrier.enrollmentPortal}
                  text='Enrollment Portal'
                  size='xsmall'
                  fill={false}
                />
              )}
              {carrier.omWebsiteLink && (
                <ExternalLinkButton
                  href={carrier.omWebsiteLink}
                  text='Website'
                  size='xsmall'
                  fill={false}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

CarrierHeader.propTypes = {
  carrier: propTypes.object.isRequired
};

export default CarrierHeader;
